import PropTypes from 'prop-types'
import { Element } from '../html/element'
import classes from './index.module.scss'

export const STATUS_COLOR = {
  1: '#3DA967',
  2: '#E03643',
  3: '#EC626D',
  4: '#9C9C9C',
  8: '#D375AE',
  9: '#F58B00',
  10: '#3A414B',
  11: '#C8781A',
  12: '#E8B714',
  active: '#3DA967',
  registered: '#9C9C9C',
  closed: '#E0505B',
  dissolved: '#9C9C9C',
}

const StatusTag = ({ status, label, style }) => {
  return (
    <Element
      style={{
        backgroundColor: STATUS_COLOR[status],
        color: '#FFFFFF',
        fontSize: 10,
        ...style,
      }}
      className={classes.statusTag}
    >
      {label}
    </Element>
  )
}

StatusTag.propTypes = {
  status: PropTypes.number,
  label: PropTypes.string,
  style: PropTypes.object,
}

export default StatusTag
